<template>
  <div class="thankyou-container">
    <div class="w100">
      <wrap-container class="thankyou-inner-container">
        <wrap-container class="cascade w50">
          <img
            src="@/assets/img/1x/transactions-accounts-transfer-ok.svg"
            width="150px"
            alt="Imagen Icono Tarjeta Tilde Verde"
          />
          <p class="title">
            ¡Listo! <br />
            Estamos preparando tu tarjeta
          </p>
          <p class="subtitle" v-if="!showText()">
            Te enviaremos tu tarjeta dentro de los próximos 10 días hábiles a
            <span data-obfuscate>{{ this.domicilio }}</span
            >.
          </p>
          <div v-if="showText()">
            <p class="subtitle">
              En los próximos 10 días hábiles recibirás tu tarjeta de débito en
              el domicilio que nos informaste.
            </p>
            <p class="subtitleinfo">
              Podrás consultar el estado del envío desde Banca Online en las
              opciones
            </p>
            <p class="subtitledirection">
              Tarjetas > Mis tarjetas > Consultas > Tarjetas en distribución.
            </p>
          </div>
          <div class="cbu_content" v-if="cbu">
            <div class="cbu_content_data">
              <p>
                CBU
                <b
                  ><span data-obfuscate>{{ cbu }}</span></b
                >
              </p>
            </div>
            <div class="cbu_content_copy">
              <a @click="copy" class="cbu">Copiar</a>
              <input type="hidden" id="cbu" :value="cbu" />
            </div>
          </div>
          <p class="detalle">
            Te enviamos el detalle de tu solicitud a
            <b
              ><span data-obfuscate>{{ email }}</span></b
            >
          </p>
        </wrap-container>
      </wrap-container>
    </div>
  </div>
</template>

<script>
import thankyouPage from "@/mixins/thankyou-page";
import WrapContainer from "@/components/core/Container";
import { DO_NOTIFICATION_TOAST } from "@/config/constants/action-types";

export default {
  name: "GraciasCajaAhorro",
  mixins: [thankyouPage],
  components: {
    WrapContainer
  },
  data() {
    return {
      color: "#1973b8"
    };
  },
  props: {},
  methods: {
    goLink() {
      this.$router.push(this.config.pasos.celular.path);
    },
    showText() {
      return (
        this.$store.getters.getConsulta().circuito === "sue" &&
        this.$store.getters.getCondicionCliente() == "00"
      );
    },
    copy() {
      let copiar = document.querySelector("#cbu");
      copiar.setAttribute("type", "text");
      copiar.select();

      navigator.clipboard
        .writeText(copiar.value)
        .then(() => {
          this.$store.dispatch(DO_NOTIFICATION_TOAST, {
            type: "success",
            message: "El CBU se copió correctamente."
          });
        })
        .catch(() => {
          this.$store.dispatch(DO_NOTIFICATION_TOAST, {
            type: "alert",
            message: "Error al Copiar el CBU."
          });
        })
        .finally(() => {
          copiar.setAttribute("type", "hidden");
          window.getSelection().removeAllRanges();
        });
    }
  },
  computed: {
    email() {
      let consulta = this.$store.getters.getConsulta();
      if (consulta && consulta.email) {
        return consulta.email;
      }
      return "";
    },
    cbu() {
      let cbu = this.$store.getters.getCBUcontratacion();
      return cbu;
    }
  }
};
</script>

<style scoped>
.cbu_content_data {
  grid-column: 1;
  grid-row: 1;
  line-height: 24px;
}
.cbu_content_copy {
  grid-column: 2;
  grid-row: 1;
  padding-top: 30px;
  text-align: center;
  font-size: 15px;
}
.cbu_content {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  height: 64px;
  border-radius: 1px;
}
.cbu {
  cursor: pointer;
  text-decoration: none;
  color: #57b7f8;
  font-size: 16px;
  margin-top: 1rem;
}
div.thankyou-container {
  color: white;
  text-align: left;
  background: #003165;
  padding: 30px;
}

p.titulo-detalle {
  font-size: 20px;
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
}

p.incluye,
p.crea {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  text-align: start;
}
p.incluye {
  font-size: 18px;
}
p.crea {
  font-size: 20px;
  margin-bottom: auto;
}

.title {
  font-size: 26px;
  font-weight: bold;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}

.box_item {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 100%;
  height: 80px;
  padding: 16px 0px 40px 0px;
  border-radius: 1px;
  background-color: #003165;
  color: #ffffff;
}
.box_img {
  grid-column: 1;
  grid-row: 1;
}
.box_text {
  grid-column: 2;
  grid-row: 1;
  width: 260px;
  height: 62px;
  padding-top: 2%;
}
.box_image {
  grid-column: 3;
  grid-row: 1;
}
.box_image_text {
  margin-left: 12px;
}
.box_text_item {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #ffffff;
  margin: 0px;
  padding-left: 16px;
}
.box_item_help {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 100%;
  height: 80px;
  padding: 16px 0px 40px 0px;
  border-radius: 1px;
  background-color: #003165;
  color: #ffffff;
}
.box_img_help {
  grid-column: 1;
  grid-row: 1;
}
.box_text_help {
  grid-column: 2;
  grid-row: 1;
  width: 280px;
  height: 62px;
}
.box_text_item_help {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #ffffff;
  margin: 0px;
}
.img_help {
  width: 16px;
  height: 16px;
}
.button {
  margin: 5% 30% 10% 30%;
}
.button_banelco {
  margin: 5% 20% 10% 20%;
}

@media screen and (min-width: 600px) {
  .thankyou-inner-container {
    display: flex;
  }
  .w50:first-child {
    padding-right: 20px;
  }
  .w50:last-child {
    padding-left: 20px;
    padding-right: 50px; /* Evitar ser tapado por flotante ayuda */
  }
  .titulo-detalle {
    margin-top: 0;
  }
}
div.box_image_links {
  display: flex;
}
.box_image_links img {
  margin-top: 22px;
}
.detalle {
  font-size: 17px;
  line-height: 24px;
  margin-bottom: 35px;
}
.box_img_link {
  color: #57b7f8;
  font-size: 16px;
  line-height: 1.6;
}
.subtitle {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #ffffff;
}

.subtitleinfo {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #ffffff;
  margin-bottom: 0px;
}

.subtitledirection {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #ffffff;
  margin-top: 0px;
}
.ingresa {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 17px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  color: #ffffff;
}
</style>
